import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container _mypage sub_page" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }
const _hoisted_4 = { class: "sub_page_con wrap_1120 mypage_inqury" }
const _hoisted_5 = { class: "sub_page_con_view con_write" }
const _hoisted_6 = { class: "flex_column" }
const _hoisted_7 = { class: "btn_wrap _default" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"deco_wrap\"><i class=\"deco_01 _medium\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_02 _small\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_03 _small\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_04 _small\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_character\"><img src=\"img/mypage_icon.png\"></i></div><div class=\"banner_wrap wrap_1120\"><h2>마이페이지</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeType(0)))
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "회원정보수정", -1)
            ]))]),
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeType(1))),
              class: "active"
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "1:1 문의", -1)
            ]))]),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeType(2)))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "내가 쓴 게시글", -1)
            ]))]),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeType(3)))
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "신청내역", -1)
            ]))])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"bread_crumbs\"><a href=\"\" class=\"icon_wrap\"><img src=\"img/home_icon.png\" alt=\"홈\"></a><span class=\"icon_wrap\"><img src=\"img/part_icon.png\" alt=\"마이페이지\"></span><a href=\"\">마이페이지</a><span class=\"icon_wrap\"><img src=\"img/part_icon.png\" alt=\"1:1문의하기\"></span><a href=\"\">1:1문의하기</a></div><div class=\"sub_con_tit\">1:1 문의 보내기</div>", 2)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _cache[13] || (_cache[13] = _createElementVNode("label", {
                for: "title",
                class: ""
              }, "제목", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "title",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form_state.title) = $event)),
                placeholder: "제목을 입력하세요"
              }, null, 512), [
                [_vModelText, $setup.form_state.title]
              ])
            ]),
            _createElementVNode("li", null, [
              _cache[14] || (_cache[14] = _createElementVNode("label", {
                for: "content",
                class: ""
              }, "내용", -1)),
              _withDirectives(_createElementVNode("textarea", {
                name: "",
                id: "content",
                class: "custom_scroll",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form_state.content) = $event)),
                placeholder: "내용을 입력하세요"
              }, null, 512), [
                [_vModelText, $setup.form_state.content]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "common_btn _gray w_180",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.router.go(-1)))
            }, "취소"),
            _createElementVNode("button", {
              class: "common_btn w_180",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.write && $setup.write(...args)))
            }, "작성완료")
          ])
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}